
import Vue, { PropType } from 'vue';
import { mergeData } from 'vue-functional-data-merge';
import { RawLocation } from 'vue-router';

export default Vue.extend({
  functional: true,
  props: {
    title: {
      type: String,
      default: undefined,
    },
    to: {
      type: [String, Object] as PropType<RawLocation>,
      default: undefined,
    },
    href: {
      type: String,
      default: '#',
    },
    disabled: {
      type: Boolean,
    },
    active: {
      type: Boolean,
    },
  },
  render(h, { props, children, slots, data, listeners }) {
    const linkContent = h(
      'span',
      { attrs: { title: props.title }, staticClass: 'slds-truncate' },
      children
    );
    const linkAttrs = {
      role: 'menuitem',
      tabindex: '-1',
      disabled: props.disabled,
    };
    const { icon } = slots();

    // eslint-disable-next-line no-param-reassign
    delete data.on;

    const isRouterLink = props.to !== undefined;

    return h(
      'li',
      {
        attrs: { role: 'presentation' },
        staticClass: 'slds-dropdown__item',
        class: { '--active': props.active },
      },
      [
        isRouterLink
          ? h(
              'router-link',
              mergeData(data, {
                props: { to: props.to },
                attrs: linkAttrs,
                on: listeners,
              }),
              [linkContent, icon]
            )
          : h(
              'a',
              mergeData(data, {
                attrs: { ...linkAttrs, href: props.href },
                on: listeners,
              }),
              [linkContent, icon]
            ),
      ]
    );
  },
});
